<template>
  <div class="register">
    <NavbarItem />
    <div class="container">
      <div class="row mt-5">
        <div class="col">
          <nav aria-label="breadcrumb" style="margin-top: 100px">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Daftar Akun</li>
            </ol>
          </nav>
        </div>
      </div>

      <div class="row justify-content-center mt-4">
        <div class="col-12">
          <h2 class="mb-4">Daftar Akun</h2>
          <form @submit.prevent="onSubmit">
            <div class="mb-3">
              <label for="nama" class="form-label">Nama</label>
              <input
                id="nama"
                v-model="nama"
                type="text"
                class="form-control"
                placeholder="Nama lengkap"
                required
              />
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                id="email"
                v-model="email"
                type="email"
                class="form-control"
                placeholder="nama@email.com"
                required
              />
            </div>
            <div class="mb-3">
              <label for="password" class="form-label">Password</label>
              <input
                id="password"
                v-model="password"
                type="password"
                class="form-control"
                placeholder="Password"
                required
              />
            </div>
            <div class="mb-3">
              <label for="konfirmasiPassword" class="form-label"
                >Konfirmasi Password</label
              >
              <input
                id="konfirmasiPassword"
                v-model="konfirmasiPassword"
                type="password"
                class="form-control"
                placeholder="Ulangi password"
                required
              />
            </div>
            <button type="submit" class="btn btn-primary w-100">Daftar</button>
          </form>
          <p class="mt-4 text-center">
            Sudah punya akun?
            <router-link to="/login">Login</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarItem from "@/components/Navbar.vue";

export default {
  name: "RegisterView",
  components: {
    NavbarItem,
  },
  data() {
    return {
      nama: "",
      email: "",
      password: "",
      konfirmasiPassword: "",
    };
  },
  methods: {
    onSubmit() {
      // Sementara: bisa diganti dengan pemanggilan API register
      console.log("Register attempt:", { nama: this.nama, email: this.email });
      alert("Daftar (belum terhubung backend). Email: " + this.email);
    },
  },
};
</script>

<style scoped></style>
